import type { FeatureAddOnKey } from './billing';

/**
 * Product release gates are intentionally code-owned rather than remotely mutable.
 * This keeps unfinished surfaces inaccessible even when billing data or legacy
 * workspace state says that an add-on is enabled.
 */
export const RELEASED_FEATURE_ADD_ON_KEYS = new Set<FeatureAddOnKey>(['relations']);

export const isFeatureAddOnReleased = (featureAddOn: FeatureAddOnKey): boolean =>
    RELEASED_FEATURE_ADD_ON_KEYS.has(featureAddOn);
